import { ReplacementType } from './replacementType.js';

export class ReplacementMapping {
    startIndex: number = 0;
    endIndex: number = 0;
    originalText: string = '';
    replacementText: string = '';
    type: ReplacementType = ReplacementType.SimpleTemplate;
    targetTemplateName: string | null = null;

    constructor() {}
}
